import React from 'react';

function SyncWarning({ color = '#808080', color2 = '#EF6700', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.95 19.05C3.1375 17.25 2 14.7625 2 12C2 7.33751 5.1875 3.43751 9.5 2.32501V4.93751C6.5875 5.96251 4.5 8.73751 4.5 12C4.5 14.075 5.35 15.9375 6.7 17.3L9.5 14.5V22H2L4.95 19.05ZM14.5 2H22L19.05 4.95C20.8625 6.75 22 9.2375 22 12C22 13.8627 21.4912 15.6037 20.6052 17.0939L19.0294 14.6177C19.3337 13.8029 19.5 12.9209 19.5 12C19.5 9.925 18.65 8.0625 17.3 6.7L14.5 9.5V2Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 23H23L18 15L13 23ZM18.4546 21.7369H17.5455V20.8947H18.4546V21.7369ZM18.4546 20.0526H17.5455V18.3684H18.4546V20.0526Z"
                fill={color2}
            />
        </svg>
    );
}

export default React.memo(SyncWarning);
